import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Typography,
    Rating,
    TextField,
    Button,
    IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import userFeedbackService from '../../../../services/userFeedbackService';
import { toast } from 'react-toastify';
import { APP_CONFIG } from '../../../../config/appConfig';

const FeedbackModal = ({ isOpen, onClose, getUserFeedback }) => {
    const [rating, setRating] = useState(0);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const userId = useSelector(state => state?.auth?.user?.id);
    const handleSave = async () => {
        setLoading(true);
        const nextRunDate = new Date();
        nextRunDate.setDate(nextRunDate.getDate() + 90);
        try {
            const query = {
                userId: userId,
                score: rating,
                comment: note,
                nextTimeRun: nextRunDate.toISOString(),
                ia: true
            }
            await userFeedbackService.addUserFeedback(query);
            toast.success('Geri bildiriminiz başarıyla oluşturuldu! Teşekkür ederiz.');
            setRating(0);
            setNote('');
            getUserFeedback();
            onClose();
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
            toast.error('Geri bildirim kaydedilirken bir hata oluştu. Lütfen tekrar deneyin.');
        }

    };

    const handleRemindLater = async () => {
        try {
            setLoading(true);
            const nextRunDate = new Date();
            nextRunDate.setDate(nextRunDate.getDate() + 30);
            const query = {
                userId: userId,
                nextTimeRun: nextRunDate.toISOString(),
                ia: true
            }
            await userFeedbackService.addUserFeedback(query);
            toast.success('Daha sonra hatırlatma işlemi başarıyla oluşturuldu.');
            setRating(0);
            setNote('');
            getUserFeedback();
            onClose();
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error('Daha sonra hatırlatma işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
        }
    };

    const handleClose = () => {
        setRating(0);
        setNote('');
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    p: 1
                }
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2 }}>
                <Typography variant="h6" component="div">
                    Değerlendirme
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ color: 'grey.500' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Yıldız Rating */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {`${APP_CONFIG.name} deneyiminizi nasıl değerlendirirsiniz?`}
                        </Typography>
                        <Rating
                            name="feedback-rating"
                            value={rating}
                            onChange={(event, newValue) => {
                                setRating(newValue);
                            }}
                            size="large"
                            sx={{ fontSize: '2rem' }}
                        />
                    </Box>

                    {/* Not Alanı */}
                    <Box>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                            Not {(note.length > 0 ? `(${note.length}/500)` : '')}
                        </Typography>
                        <TextField
                            multiline
                            rows={4}
                            fullWidth
                            placeholder="Görüşlerinizi paylaşın..."
                            value={note}
                            inputProps={{ maxLength: 500 }}
                            onChange={(e) => setNote(e.target.value)}
                            variant="outlined"
                        />
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 2, gap: 1 }}>
                <Box sx={{ display: 'flex', width: '100%', gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleRemindLater}
                        sx={{ flex: 1 }}
                        disabled={loading}
                    >   {loading ? 'Yükleniyor...' : '   Daha Sonra Hatırlat'}
                     
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        sx={{ flex: 1 }}
                    >
                        Kapat
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{ flex: 1 }}
                        disabled={rating === 0 || rating == null || note === null || note.trim() === ''||loading}
                    >
                        {loading ? 'Yükleniyor...' : 'Kaydet'}
                        
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default FeedbackModal;